import React from 'react';
import { FaRocket, FaPlus } from 'react-icons/fa';
import './EmptyFleetMessage.css';

interface EmptyFleetMessageProps {
  onStartTutorial: () => void;
}

export const EmptyFleetMessage: React.FC<EmptyFleetMessageProps> = ({
  onStartTutorial
}) => {
  return (
    <div className="empty-fleet-container">
      <div className="empty-fleet-content">
        <div className="empty-fleet-icon">
          <FaRocket />
        </div>
        
        <h2 className="empty-fleet-title">
          ¡Empieza a construir tu flota!
        </h2>
        
        <p className="empty-fleet-description">
          Aún no tienes naves en tu flota. Explora el catálogo y añade tu primera nave para comenzar tu aventura en el universo de Star Citizen.
        </p>
        
        <button 
          className="start-tutorial-btn"
          onClick={onStartTutorial}
        >
          <FaPlus /> Comenzar tutorial
        </button>
      </div>
    </div>
  );
};
